import styled from "@emotion/styled";

import { Value } from "src/components/Unifize/Status/styles";

const StyledStatus = styled(Value)`
  text-overflow: inherit;
`;

export default StyledStatus;
